<section class="header">
  <div class="background-container"></div>
  <div class="px-1 px-md-5 align-items-center d-flex justify-content-between main-content" *ngIf="!isMobile">
    <div class="d-none col-4 d-md-block p-0"></div>
    <div class="col-md-4 d-flex justify-content-center p-0">
      <a href="http://wsmcasino.com/">
        <img src="/assets/images/web3-wall--street.png" alt height="32" class="top-logo" />
      </a>
    </div>
    <div class="col-md-4 d-flex justify-content-center justify-content-lg-end gap-3 p-0">
      <div class="btn-group language" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle amountType d-flex align-items-center black">
          <img class="flag-icon" src="./assets/images/flags/{{ selectedLanguage?.flag }}.svg" alt="" />
          <!-- <span class="ms-1 font-13 text-capitalize fw-regular text-white">{{ selectedLanguage?.name }}</span> -->
          <!-- <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"></svg-icon> -->
        </div>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
            (click)="changeLanguage(lang.value)">
            <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="" />
            <span class="font-12" [ngClass]="{
                'text-end': isRtoLSelected && lang.value.includes('zh')
              }">{{ lang.name }}</span>
          </li>
        </ul>
      </div>
      <a [href]="enterSiteLink || getJoinNowLink()" class="mt-3 mb-3 me-4">
        <button class="enter-site text-uppercase text-nowrap" translate>
          enter_site
        </button>
      </a>
    </div>
  </div>

  <div class="align-items-center d-flex justify-content-between px-3 main-content" *ngIf="isMobile">
    <div class="d-flex justify-content-center p-0">
      <a href="http://wsmcasino.com/">
        <img src="/assets/images/web3-wall--street.png" alt height="32" class="top-logo" />
      </a>
    </div>
    <div class="d-flex justify-content-center">
      <div class="btn-group language" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle amountType d-flex align-items-center black">
          <img class="flag-icon" src="./assets/images/flags/{{ selectedLanguage?.flag }}.svg" alt="" />
          <!-- <span class="ms-1 font-13 text-capitalize fw-regular text-white">{{ selectedLanguage?.name }}</span> -->
          <!-- <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"></svg-icon> -->
        </div>
        <ul *dropdownMenu class="dropdown-menu" role="menu" [ngClass]="{
                      'dropdown-menu-left': isMobile,
                      'dropdown-menu-right': !isMobile
                    }">
          <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
            (click)="changeLanguage(lang.value)">
            <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="" />
            <span class="font-12" [ngClass]="{
                'text-end': isRtoLSelected && lang.value.includes('zh')
              }">{{ lang.name }}</span>
          </li>
        </ul>
      </div>
      <a [href]="
          enterSiteLink ||
          'https://record.wsmaffiliates.com/_OYeaPWW-7QHUOsjNOfgKeWNd7ZgqdRLk/1/'
        " class="mt-3 mb-3 " [ngClass]="isRtoLSelected ? 'me-3': 'ms-3'
              ">
        <button class="enter-site text-uppercase text-nowrap" translate>
          enter_site
        </button>
      </a>
    </div>
  </div>
</section>